import * as React from 'react';
import { useState } from 'react';
import { BaseUser } from '../models/user';
import { PaginatedContext, ContextValue } from '../components/management/pagination/paginated-context';
import { UserSortingOptions } from '../models/enums/adminSortingOptions';

const defaultState: PaginatedContext<BaseUser> = {
  loading: false,
  results: [],
  currentPage: 1,
  totalResults: 0,
  pageSize: 60,
  orderColumn: UserSortingOptions.Name,
  orderDirection: UserSortingOptions.Ascending,
  searchTerm: null
};

/** Context for sharing user results to be displayed in a paginated form */
const PaginatedUserContext = React.createContext<ContextValue<BaseUser>>(null);

const PaginatedUserConsumer = PaginatedUserContext.Consumer;

const PagedUserProvider = props => {
  const [state, setState] = useState<PaginatedContext<BaseUser>>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return <PaginatedUserContext.Provider value={{ ...state, dispatch }}>{props.children}</PaginatedUserContext.Provider>;
};

export { PaginatedUserContext, PagedUserProvider, PaginatedUserConsumer };
